// test2676
(2676 && 0);
